import React from 'react';

const SliderNavigationButtons = ({
  selectedIndex,
  setSelectedIndex,
  count,
  isDark,
  isFullHeight,
}) => {
  const dots = new Array(count).fill(0);
  const previous = () => {
    if (selectedIndex) {
      setSelectedIndex((index) => --index);
    } else {
      setSelectedIndex(count - 1);
    }
    // selectedIndex && setSelectedIndex((index) => --index);
    // transition for full width slider :
    const slides = document.querySelectorAll('.marketing-section.full-height');
    if (slides && isFullHeight) {
      slides[0].classList.add('fade-in');
      setTimeout(() => {
        slides[0].classList.remove('fade-in');
      }, 700);
    }

    const packageSlides = document.querySelectorAll('.package-card-container');
    if (packageSlides && isFullHeight) {
      packageSlides[0].classList.add('fade-in');
      setTimeout(() => {
        packageSlides[0].classList.remove('fade-in');
      }, 700);
    }
  };
  const next = () => {
    if (selectedIndex < count - 1) {
      setSelectedIndex((index) => ++index);
    } else if (selectedIndex == count - 1) {
      setSelectedIndex(0);
    }
    // selectedIndex < count - 1 && setSelectedIndex((index) => ++index);
    // transition for full width slider :
    const slides = document.querySelectorAll('.marketing-section.full-height');
    if (slides && isFullHeight) {
      slides[0].classList.add('fade-in');
      setTimeout(() => {
        slides[0].classList.remove('fade-in');
      }, 700);
    }

    const packageSlides = document.querySelectorAll('.package-card-container');
    if (packageSlides && isFullHeight) {
      packageSlides[0].classList.add('fade-in');
      setTimeout(() => {
        packageSlides[0].classList.remove('fade-in');
      }, 700);
    }
  };
  return (
    <div className="buttons-group">
      <svg
        className="prev-button"
        onClick={previous}
        width="48"
        height="49"
        viewBox="0 0 48 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="24"
          cy="24.9766"
          r="23.5"
          stroke={isDark ? '#9699AB' : 'white'}
        />
        <path
          d="M14.2892 24.9761L29.7952 16.0237L29.7952 33.9285L14.2892 24.9761Z"
          fill={isDark ? '#9699AB' : 'white'}
        />
      </svg>
      {dots?.map((slide, index) => (
        <span
          className={`dot ${index === selectedIndex ? 'selected' : ''} ${
            isDark ? 'dark' : ''
          } `}
          onClick={() => setSelectedIndex(index)}
        />
      ))}
      <svg
        className="next-button"
        onClick={next}
        width="48"
        height="49"
        viewBox="0 0 48 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="24"
          cy="24.9766"
          r="23.5"
          transform="rotate(-180 24 24.9766)"
          stroke={isDark ? '#9699AB' : 'white'}
        />
        <path
          d="M33.7108 24.977L18.2048 33.9294L18.2048 16.0246L33.7108 24.977Z"
          fill={isDark ? '#9699AB' : 'white'}
        />
      </svg>
    </div>
  );
};

export default SliderNavigationButtons;
